export enum ChatRoomStatus {
  DEFAULT = 0,
  WAITING = 1,
  PROCESSING = 2,
  COMPLETE = 3,
}

export interface AdminResponse {
  message: string | null;
  memberId: number | null;
  messageStatus: number | null;
  messageId?: string | null;
  image_urls?: string[] | null;
}

export enum MessageStatus {
  Rejected = 0,
  Changed = 1,
  Approve = 2,
  Review = 3,
  Manual = 4,
}
